import { Col, Row, Table } from "react-bootstrap";
import usePageTitle from "common/usePageTitle";

function PricePage() {
  usePageTitle("Cjenik");

  return (
    <div>
      <h1 className="mb-5">Cjenik</h1>

      <Row>
        <Col md={10} lg={8} xxl={6}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Predmet</th>
                <th>Sati</th>
                <th>Cijena</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Hrvatski jezik</td>
                <td>42</td>
                <td>441 €</td>
              </tr>
              <tr>
                <td>Matematika A (viša razina)</td>
                <td>50</td>
                <td>525 €</td>
              </tr>
              <tr>
                <td>Matematika B (osnovna razina)</td>
                <td>42</td>
                <td>441 €</td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
      <p>
        <em>U cijenu je uračunat iznos PDV-a. Mogućnost plaćanja na rate.</em>
      </p>
    </div>
  );
}

export default PricePage;
